@if (price) {
    <span
        class="product-price m-8:b"
        aria-hidden="true"
    >
        {{ price | splitCurrency: 'before' }},<sup>{{ price | splitCurrency: 'after' }}</sup
        >&nbsp;<span class="currency-sign">€</span>
    </span>
    <span class="visibly-hidden">{{ price | splitCurrency: 'before' }},{{ price | splitCurrency: 'after' }}€</span>
} @else {
    <span
        class="product-price"
        aria-hidden="true"
    >
        --,<sup>--</sup>&nbsp;<span class="currency-sign">€</span>
    </span>
    <span class="visibly-hidden">Es kann noch kein Preis angezeigt werden.</span>
}
